import type {
    AffectedObject,
    AffectedObjectKind,
    FeedbackImpact,
    FeedbackType,
} from './types';

export const FEEDBACK_TYPE_LABELS: Record<FeedbackType, string> = {
    bug: 'Bug',
    improvement: 'UX improvement',
};

export const FEEDBACK_IMPACT_LABELS: Record<FeedbackImpact, string> = {
    blocking: 'Blocking',
    workaround_exists: 'Workaround exists',
    cosmetic: 'Cosmetic',
};

export const AFFECTED_OBJECT_KIND_LABELS: Record<AffectedObjectKind, string> = {
    aircraft: 'Aircraft',
    collection: 'Collection',
    ad_number: 'AD number',
    htc_number: 'HTC number',
};

export const NO_VALUE = '—';

/** `Aircraft N123AB`, or a dash when the feedback names no object. */
export function formatAffectedObject(obj: AffectedObject | null): string {
    if (!obj) return NO_VALUE;
    return `${AFFECTED_OBJECT_KIND_LABELS[obj.kind]} ${obj.value}`;
}

/** A short reference for the feedback, e.g. "#12", to quote when talking to support. */
export function formatFeedbackId(id: number): string {
    return `#${id}`;
}
